// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-core-pages-page-template-tsx" + "-" + "30e883dd3ea31006d7c8" + ".js";
};